import React from "react";
import "./Loader.css"; // Import the CSS above

export const Loader = () => {
  return (
    <div className="full-page-loader">
      <div className="spinner"></div>
    </div>
  );
};
